export function Label({ children, className = "", ...props }) {
  return (
    <label {...props} className={`form-label ${className}`}>
      {children}
    </label>
  );
}
